export const pastaNames = [
  'Angel hair',
  'Cannelloni',
  'Capellini',
  'Conchiglie',
  'Ditalini',
  'Elbow macaroni',
  'Farfalle',
  'Fettuccine',
  'Fusilli',
  'Lasagna',
  'Linguine',
  'Manicotti',
  'Orecchiette',
  'Orzo',
  'Pappardelle',
  'Pastina',
  'Penne',
  'Radiatore',
  'Rigatoni',
  'Rotelle',
  'Rotini',
  'Spaghetti',
  'Tagliatelle',
  'Torchio',
  'Vermicelli',
  'Ziti',
]

export const pasta = {
  Pasta: {
    White: {
      Cooked: ['White pasta (cooked)'],
      Dry: ['White pasta (dry)'],
    },
    'Whole wheat': {
      Cooked: ['Whole wheat pasta (cooked)'],
      Dry: ['Whole wheat pasta (dry)'],
    },
  },
}
